import { ChangeEvent, ReactElement, useContext } from 'react';

import 'styles/react-data-grid/react-data-grid-checkbox.css';
import ReactDataGridContext from '../../Context/ReactDataGridContext';
import { IFormatterProps } from '../../../@types/workspaceTypes';

const React = require('react');

type ICheckboxEditorProps = {
  value: boolean;
  rowIdx: number;
  column: {
    key: string;
    onCellChange: (rowIdx: number, key: string, dependentValues: object, e: ChangeEvent) => {};
  };
  dependentValues: object;
  disabled: boolean;
};

/**
 * Data grid 'checkbox selection' component.
 * Uses the handleRowSelect function from context to ensure we access an up-to-date version of the function regardless of any memoised/conditional renders between this and the grid.
 */
const ReactDataGridCheckboxEditor = ({
  rowIdx,
  column,
  dependentValues,
  value,
}: IFormatterProps<{ id?: number; uuid?: string }>): ReactElement => {
  const { handleRowSelect } = useContext(ReactDataGridContext);

  const handleChange = (e: ChangeEvent) => {
    handleRowSelect(rowIdx, column.key, dependentValues.rowData, e);
  };

  const checkboxName: string = `checkbox${rowIdx}`;

  return (
    <div className="react-grid-checkbox-container checkbox-align">
      <input
        className="react-grid-checkbox"
        type="checkbox"
        name={checkboxName}
        onChange={handleChange}
        checked={value}
      />
      <label htmlFor={checkboxName} className="react-grid-checkbox-label" />
    </div>
  );
};

export default ReactDataGridCheckboxEditor;
